<evsb-base-card-header [variant]="variant" [label]="label">
  <div class="relative flex w-32 md:w-40 h-full justify-end">
    <img [src]="imgSrc" class="absolute bottom-0 max-h-32 md:max-h-40 max-w-32 md:max-w-40" />
  </div>
  <ng-content select="[heading]" heading></ng-content>
</evsb-base-card-header>